export default __webpack_public_path__ + "static/image-22-951604306b3bcb086f961f65e3e538e9.jpg";